import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/seo-data";

const darkCategories = [
  {
    name: "Jackets",
    url: categories[3].url,
    image:
      "https://readdy.ai/api/search-image?query=Stylish%20modern%20jacket%20on%20warm%20cream%20minimalist%20background%2C%20clean%20product%20photography%2C%20soft%20natural%20studio%20lighting%2C%20simple%20elegant%20composition%2C%20neutral%20warm%20tones%2C%20high%20detail%20fashion%20editorial%20style&width=400&height=400&seq=dark-cat-jacket-v2&orientation=squarish",
  },
  {
    name: "Pants/Shorts",
    url: categories[4].url,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20casual%20pants%20neatly%20displayed%20on%20light%20beige%20textured%20surface%2C%20minimalist%20product%20photography%2C%20soft%20daylight%2C%20clean%20composition%2C%20warm%20neutral%20colors%2C%20editorial%20quality%20aesthetic&width=400&height=400&seq=dark-cat-pants-v2&orientation=squarish",
  },
  {
    name: "Headwear",
    url: categories[5].url,
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20baseball%20cap%20on%20clean%20cream%20textured%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20simple%20modern%20style%2C%20warm%20neutral%20aesthetic%2C%20high%20detail%20editorial%20fashion&width=400&height=400&seq=dark-cat-headwear-v2&orientation=squarish",
  },
  {
    name: "Sets",
    url: categories[6].url,
    image:
      "https://readdy.ai/api/search-image?query=Coordinated%20fashion%20ensemble%20on%20warm%20beige%20backdrop%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20composition%2C%20modern%20editorial%20style%2C%20harmonious%20neutral%20tones%2C%20lifestyle%20aesthetic&width=400&height=400&seq=dark-cat-sets-v2&orientation=squarish",
  },
];

export default function DarkCategorySection() {
  const { t } = useTranslation("home");

  return (
    <section className="bg-foreground-950 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="inline-block border border-white/30 text-white/80 text-xs font-medium px-4 py-1.5 rounded-full">
              {t("allCategories")}
            </span>
            <h2 className="mt-6 text-3xl md:text-5xl font-heading font-bold text-white leading-tight">
              {t("discoverTitle1")}
              <br />
              {t("discoverTitle2")}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {darkCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group cursor-pointer"
            >
              <div className="bg-background-50 rounded-2xl overflow-hidden aspect-square">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="mt-4">
                <h3 className="text-sm font-semibold text-white">{cat.name}</h3>
                <p className="text-xs text-white/60 mt-1">Sprawdź teraz</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}